const commercial = {
  commercial: {
    pageHeader: 'Projekty komercyjne',
    pageSubHeading: 'Cyfrowe narzędzia i usługi firmy Enphase do tworzenia i zarządzania flotą komercyjną.',
    contactUsMessage: 'W przypadku pytań związanych z usługami komercyjnymi prosimy o kontakt',
    contactUsEmail: 'E-mail',
    contactUsPhone: 'Tel.',
    contactUsHelpText: 'Czy potrzebujesz dalszej pomocy?',
    contactUsRedirectText: 'Kliknij tutaj',
    bomFormTitle: 'Kalkulator BOM',
    bomFormText: 'Wybierz dowolną opcję, aby kontynuować',
    bomFormNewBomOption: 'Oblicz nowe zestawienie materiałowe (BOM)',
    bomFormExistingBomOption: 'Otwórz/edytuj istniejące zestawienie materiałowe (BOM)',
    leadCardTitle: 'Moi potencjalni klienci',
    leadCardDesc: 'Twórz i zarządzaj potencjalnymi klientami komercyjnymi',
    systemCardTitle: 'Systemy',
    systemCardDesc: 'Twórz lokalizacje komercyjne i monitoruj swoją flotę',
    bomCardTitle: 'Kalkulator BOM',
    bomCardDesc: 'Oszacuj BOM (zestawienie materiałowe) i koszt projektu',
    solargrafCardTitle: 'Narzędzie ofertowe i do projektowania (Solargraf)',
    solargrafCardDesc: 'Uzyskaj dostęp do kompleksowego narzędzia ofertowego i do projektowania',
    resourceCardTitle: 'Zasoby',
    resourceCardDesc: 'Uzyskaj dostęp do wszystkich zasobów komercyjnych',
    commResourceTitle: 'Zasoby komercyjne',
    commResourceDesc: 'Uzyskaj dostęp do wszystkich zasobów komercyjnych',
    euResourceTitle: 'Enphase University (szkolenie)',
    euResourceDesc: 'Uzyskaj dostęp do szkolenia komercyjnego Enphase',
    serviceCardTitle: 'Usługi komercyjne',
    serviceCardDesc: 'Uzyskaj dostęp do wszystkich usług komercyjnych',
    drsServiceTitle: 'Zasoby usługi recenzowania projektu',
    drsServiceDesc: 'Uzyskaj dostęp do komercyjnej usługi recenzowania projektu',
    permitServiceTitle: 'Usługa pomocy w uzyskaniu zezwolenia',
    permitServiceDesc: 'Uzyskaj dostęp do komercyjnej usługi pomocy w uzyskaniu zezwolenia',
    contactCardTitle: 'Skontaktuj się z nami',
    contactCardDesc: 'Jesteśmy zawsze do dyspozycji'
  }
};

export default commercial;
